export default __webpack_public_path__ + "images/29d7ff1dfbc0871196097ab696f0c005.svg";